import styled from '@emotion/styled/macro';
import { Card } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import { FlexWrapper, GridBox } from '../../../../theme/common_style';

const HmsOsType = ({ title, content, loading, cols, onClick, active }) => {
  return (
    <Card
      prefixCls="hms-card"
      loading={loading}
      style={{ textAlign: 'left', width: '100%', height: '100%', borderRadius: 16 }}>
      <FlexWrapper gap="12px" align="center" justify="start" style={{ height: '100%' }}>
        <ContentWrapper>
          <Title>{title}</Title>
          <GridBox cols={cols}>
            {content?.map((item, index) => (
              <>
                <InfoBlock key={index} border={index !== 0}>
                  <ImageWrapper onClick={() => item?.filterKey && onClick(item?.filterKey)}>
                    {item.icon}
                  </ImageWrapper>
                  <Count color={active?.includes(item?.filterKey)}>{item.value}</Count>
                </InfoBlock>
              </>
            ))}
          </GridBox>
        </ContentWrapper>
      </FlexWrapper>
    </Card>
  );
};

HmsOsType.propTypes = {
  title: PropTypes.string,
  cols: PropTypes.number,
  content: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.element,
      label: PropTypes.string,
      value: PropTypes.number
    })
  ),
  loading: PropTypes.bool,
  onClick: PropTypes.func,
  active: PropTypes.arrayOf(PropTypes.string)
};

export default HmsOsType;

// Styled components
const ImageWrapper = styled.div`
  background-color: ${({ bg }) => bg};
  width: 28px;
  height: 28px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  cursor: pointer;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 100%;
`;

const Title = styled.div`
  font-family: Plus Jakarta Sans;
  font-weight: 400;
  font-size: 16px;
  color: #7a7b7a;
`;

const InfoBlock = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  border-left: ${({ border }) => (border ? '1px solid #d9d9d9' : 'none')};
  padding-left: ${({ border }) => (border ? '16px' : '0px')};
`;

const Count = styled.div`
  font-size: 28px;
  font-weight: 600;
  color: ${({ color, theme }) => (color ? theme.primaryColor : '#606060')};
  margin-bottom: -7px;
`;
